import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeResourceUrlPipe } from '../_pipes/safe-resource-url.pipe';
import { TableModule } from 'primeng/table';
import { UploadModalComponent } from './components/upload-modal/upload-modal.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { ListFilterComponent } from './components/list-filter/list-filter.component';

@NgModule({
  declarations: [
    SafeResourceUrlPipe,
    UploadModalComponent,
    ListFilterComponent
  ],
  imports: [
    CommonModule,
    TableModule,
    DialogModule,
    ButtonModule,
    ProgressBarModule,
    InputTextModule,
    RippleModule
  ],
  exports:
  [
    SafeResourceUrlPipe,
    TableModule,
    UploadModalComponent,
    ListFilterComponent
  ]
})
export class SharedModule { }
